import ResolvedInvestmentsWidget from './ResolvedInvestmentsWidget'

export default ResolvedInvestmentsWidget
